import Parser from 'ua-parser-js';

// User agent checks
export const checkIsPrerenderUA = () => /prerender/i.test(Parser.UAParser().ua);
export const checkIsBotUA = () => /bot/i.test(Parser.UAParser().ua);
